import React, { FC, useState, useMemo, useRef } from 'react';
import { ISOPreviewProps } from './types';
import { pdfjs, Document, Page } from 'react-pdf';
import { DocumentSectionStyled, DocumentViewStyled } from './styled';
import { Spinner, SpinnerSize, Box } from '@bechtel/gds';
import 'react-pdf/dist/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

export const IsoPreview: FC<ISOPreviewProps> = ({ url }) => {
  const pdfDocumentRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState<number>(25);
  const [progress, setProgress] = useState(true);

  const onPageLoadSuccess = (page) => {
    if (!(pdfDocumentRef && pdfDocumentRef.current)) {
      return;
    }
    const widthScale = (pdfDocumentRef ? pdfDocumentRef?.current?.clientWidth : 0) / page.originalWidth;
    const heightScale = (pdfDocumentRef ? pdfDocumentRef?.current?.clientHeight : 0) / page.originalHeight;
    const pageScale = Math.min(widthScale, heightScale);
    if (scale !== pageScale) {
      setScale(widthScale * 100 - 3);
    }
  };

  const file = useMemo(() => ({ url: url, withCredentials: true }), [url]);
  return (
    //@ts-ignore Box style needed here for flex
    <DocumentSectionStyled id="pdfDocument" ref={pdfDocumentRef}>
      <DocumentViewStyled>
        {progress && (
          <Box
            flexGrow={{ sm: 1 }}
            alignItems={{ sm: 'center' }}
            justifyContent={{ sm: 'center' }}
            style={{ height: '100%' }}
          >
            <Spinner size={SpinnerSize.MEDIUM}></Spinner>
          </Box>
        )}
        <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }} style={{ height: '100%' }}>
          <Document
            file={file}
            onLoadError={() => setProgress(false)}
            onLoadSuccess={() => setProgress(false)}
            loading={<>&nbsp;</>}
          >
            <Page
              pageNumber={1}
              renderAnnotationLayer={false}
              scale={scale / 100}
              key={1}
              onLoadSuccess={onPageLoadSuccess}
            />
          </Document>
        </Box>
      </DocumentViewStyled>
    </DocumentSectionStyled>
  );
};
